import React, { useMemo } from 'react';
import { Column } from '@shared/ui/atoms/StructuralLayout';
import { useTranslation } from "react-i18next";
import { BodyRegular, BodySmall } from '@shared/ui/atoms/fonts/Body';
import { Checkbox } from '@shared/ui/atoms/Checkbox';
import { useDispatch, useSelector } from "react-redux";
import { selectedFloorId, selectedOffice, setFloor } from "../models/room-finder.duck";
import { selectAllOfficeEntities } from '@features/desks/store/advanceHotDeskingSetup.duck';
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';

export function FloorFilterOption() {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const office = useSelector(selectedOffice);
  const allOffices = useSelector(selectAllOfficeEntities);
  const currentFloorId = useSelector(selectedFloorId);

  const floors = useMemo(() => {
    if (!office) return [];
    return allOffices
      .filter((o: OfficeEntity) => o.parentId === office.id && o.floor)
      .sort((a: OfficeEntity, b: OfficeEntity) => a.label.localeCompare(b.label));
  }, [office, allOffices]);

  if (floors.length === 0) return null;

  return (
    <Column style={{marginBottom: 20}}>
      <BodyRegular weight={600} style={{marginBottom: 16}}>{t('room-finder.floor-filter.title')}</BodyRegular>

      <Checkbox value={!currentFloorId}
                style={{marginBottom: 12}}
                onChange={() => dispatch(setFloor(undefined))}
                text={'room-finder.floor-filter.all-floors'} />

      {floors.map((floor: OfficeEntity) => (
        <Checkbox key={floor.id}
                  value={currentFloorId === floor.id}
                  style={{marginBottom: 12}}
                  onChange={() => dispatch(setFloor(floor.id))}>
          <BodySmall>{floor.label}</BodySmall>
        </Checkbox>
      ))}
    </Column>
  )
}
